import request from './request';

export const communityAPI = {
  /** 获取社区作品列表 */
  getPosts: (params) => request.get('/community/posts', { params }),
  /** 获取单个作品详情 */
  getPostById: (id) => request.get(`/community/posts/${id}`),
  /** 点赞作品 */
  likePost: (id) => request.post(`/community/posts/${id}/like`),
  /** 评论作品 */
  commentPost: (id, data) => request.post(`/community/posts/${id}/comment`, data),
};

/**
 * SWR fetcher — 供 useSWR 直接使用
 * 兼容 ApiResult 格式（request 拦截器已解包 data）
 */
export const communityFetcher = async (params) => {
  const data = await communityAPI.getPosts(params);
  // request 拦截器已返回 data.data，即真正的业务数据
  return data?.posts ?? data ?? [];
};

export default communityAPI;
